import { MD_CHIP_COLORS, cA } from './colors';

export interface MDChipProps {
  md: string;
  compact?: boolean;
}

export function MDChip({ md, compact }: MDChipProps) {
  const color = MD_CHIP_COLORS[md] || '#52525b';
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: compact ? '1px 5px' : '2px 7px',
        borderRadius: 4,
        fontSize: compact ? 8 : 9,
        fontWeight: 700,
        background: cA(color, '18'),
        color: color,
        letterSpacing: '0.02em',
        lineHeight: 1.3,
      }}
    >
      {md}
    </span>
  );
}
